import Diagnose from '@/types/Diagnose';

export default class PatAnamnese {
    /** PK | erforderlich */
    public patanamnese_id : any | null = null;
    /** FK: Patient Verweis auf Tab. Patienten | erforderlich */
    public patnr : any | null = null;
    /** Datum | erforderlich */
    public datum : any | null = null;
    /** max. 255 Zeichen  */
    public untersuchungsgrund : any | null = null;
    /** max. 255 Zeichen  */
    public anamnese_aktuell : any | null = null;
    /** max. 500 Zeichen  */
    public anamnese : any | null = null;
    /** max. 255 Zeichen  */
    public reiseanamnese_beruflich : any | null = null;
    /** max. 255 Zeichen  */
    public reiseanamnese_privat : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_masern : any | null = null;
    public kk_masern_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_mumps : any | null = null;
    public kk_mumps_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_roeteln : any | null = null;
    public kk_roeteln_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_windpocken : any | null = null;
    public kk_windpocken_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_keuchhusten : any | null = null;
    public kk_keuchhusten_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_scharlach : any | null = null;
    public kk_scharlach_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public kk_nicht_erinnerlich : any | null = null;
    public kk_nicht_erinnerlich_n : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fam_haeufige_krankheiten : any | null = null;
    public fam_haeufige_krankheiten_n : any | null = null;
    /** max. 255 Zeichen  */
    public fam_haeufige_krankheiten_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_medikamente : any | null = null;
    public gp_medikamente_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_medikamente_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_allergien : any | null = null;
    public gp_allergien_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_allergien_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_medikamentenunvertraeglichkeit : any | null = null;
    public gp_medikamentenunvertraeglichkeit_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_medikamentenunvertraeglichkeit_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_alkohol : any | null = null;
    public gp_alkohol_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_alkohol_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_rauchen : any | null = null;
    public gp_rauchen_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_rauchen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_drogen : any | null = null;
    public gp_drogen_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_drogen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_sport : any | null = null;
    public gp_sport_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_sport_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_durchfall_verstopfung : any | null = null;
    public gp_durchfall_verstopfung_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_durchfall_verstopfung_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_urinieren : any | null = null;
    public gp_urinieren_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_urinieren_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_schlafstoerungen : any | null = null;
    public gp_schlafstoerungen_n : any | null = null;
    /** max. 255. Zeichen */
    public gp_schlafstoerungen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_risiken_arbeitsplatz : any | null = null;
    public gp_risiken_arbeitsplatz_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_risiken_arbeitsplatz_text : any | null = null;
    /** max. 1 Zeichen | j/n  */
    public gp_beruf : any | null = null;
    public gp_beruf_n : any | null = null;
    /** max. 255 Zeichen */
    public gp_beruf_text : any | null = null;
    /** max. 255 Zeichen  */
    public gp_zahnarzt_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_augen : any | null = null;
    public gp_augen_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_augen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_obere_luftwege : any | null = null;
    public gp_obere_luftwege_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_obere_luftwege_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_ohren : any | null = null;
    public gp_ohren_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_ohren_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_atemwege : any | null = null;
    public gp_atemwege_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_atemwege_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_herzkreislaufsystem : any | null = null;
    public gp_herzkreislaufsystem_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_herzkreislaufsystem_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_verdauungstrakt : any | null = null;
    public gp_verdauungstrakt_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_verdauungstrakt_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_niere_harnwege : any | null = null;
    public gp_niere_harnwege_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_niere_harnwege_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_haut : any | null = null;
    public gp_haut_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_haut_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_bewegungsapparat : any | null = null;
    public gp_bewegungsapparat_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_bewegungsapparat_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_stoffwechsel : any | null = null;
    public gp_stoffwechsel_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_stoffwechsel_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_infektionskrankheiten : any | null = null;
    public gp_infektionskrankheiten_n : any | null = null;
    /**  */
    public gp_infektionskrankheiten_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_tumor : any | null = null;
    public gp_tumor_n : any | null = null;
    /** max. 255  Zeichen  */
    public gp_tumor_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_erkrankungen_zns : any | null = null;
    public gp_erkrankungen_zns_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_erkrankungen_zns_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_psyche : any | null = null;
    public gp_psyche_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_psyche_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_operationen : any | null = null;
    public gp_operationen_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_operationen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_unfaelle : any | null = null;
    public gp_unfaelle_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_unfaelle_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_andere : any | null = null;
    public gp_andere_n : any | null = null;
    /** max. 255 Zeichen  */
    public gp_andere_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_tropen : any | null = null;
    /** max. 255 Zeichen  */
    public gp_tropen_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_ausland : any | null = null;
    /** max. 255 Zeichen  */
    public gp_ausland_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public gp_derzeit : any | null = null;
    /** max. 255 Zeichen  */
    public gp_derzeit_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fr_kinder : any | null = null;
    public fr_kinder_n : any | null = null;
    /** max. 255 Zeichen  */
    public fr_kinder_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fr_fehlgeburten : any | null = null;
    public fr_fehlgeburten_n : any | null = null;
    /** max. 255 Zeichen  */
    public fr_fehlgeburten_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fr_schwanger : any | null = null;
    /** max. 255 Zeichen  */
    public fr_schwanger_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fr_menstruationsbeschwerden : any | null = null;
    public fr_menstruationsbeschwerden_n : any | null = null;
    /** max. 255 Zeichen  */
    public fr_menstruationsbeschwerden_text : any | null = null;
    /** max. 1 Zeichen | j/n */
    public fr_kontrazeption : any | null = null;
    public fr_kontrazeption_n : any | null = null;
    /** max. 255 Zeichen  */
    public fr_kontrazeption_text : any | null = null;
    /** max. 255 Zeichen  */
    public fr_letzte_menstruation : any | null = null;
    /** max. 255 Zeichen  */
    public fr_gynbegutachtung : any | null = null;
    /** max. 255 Zeichen  */
    public fr_anamnese : any | null = null;
    /** Nummer */
    public st_rr_links_syst : any | null = null;
    /** Nummer */
    public st_rr_links_diast : any | null = null;
    /** Nummer */
    public st_rr_rechts_syst : any | null = null;
    /** Nummer */
    public st_rr_rechts_diast : any | null = null;
    /** Nummer */
    public st_puls : any | null = null;
    /** Nummer */
    public st_koerpergroesse : any | null = null;
    /** Nummer */
    public st_koerpergewicht : any | null = null;
    /** max. 255 Zeichen  */
    public st_allgemeinzustand : any | null = null;
    /** max. 255 Zeichen  */
    public st_ernaehrungszustand : any | null = null;
    /** max. 255 Zeichen  */
    public st_caput_collum : any | null = null;
    /** max. 255 Zeichen  */
    public st_cor_pulmo : any | null = null;
    /** max. 255 Zeichen  */
    public st_abdomen : any | null = null;
    /** max. 255 Zeichen  */
    public st_ws_nl : any | null = null;
    /** max. 255 Zeichen  */
    public st_haut : any | null = null;
    /** max. 255 Zeichen  */
    public st_neuro : any | null = null;
    /** max. 255 Zeichen  */
    public st_gefaesse : any | null = null;
    /** max. 255 Zeichen  */
    public st_gelenke_muskeln : any | null = null;

    constructor(data?: Partial<PatAnamnese>) {
        Object.assign(this, data);
    }
}
